import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=0ae298d4&scoped=true&"
import script from "./reset-password.vue?vue&type=script&lang=js&"
export * from "./reset-password.vue?vue&type=script&lang=js&"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=0ae298d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae298d4",
  null
  
)

export default component.exports